import React from 'react';
import { useSelector } from 'react-redux';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

import MapPoint1 from 'images/MapPoint1.png';
import MapPoint2 from 'images/MapPoint2.png';
import MapPoint3 from 'images/MapPoint3.png';
import MapPoint4 from 'images/MapPoint4.png';
import MapPoint5 from 'images/MapPoint5.png';
// import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const icon1 = L.icon({
  iconUrl: MapPoint1,
  iconSize: [30, 30], // size of the icon
  iconAnchor: [15, 15], // point of the icon which will correspond to marker's location
});
const icon2 = L.icon({
  iconUrl: MapPoint2,
  iconSize: [30, 30], // size of the icon
  iconAnchor: [15, 15], // point of the icon which will correspond to marker's location
});
const icon3 = L.icon({
  iconUrl: MapPoint3,
  iconSize: [30, 30], // size of the icon
  iconAnchor: [15, 15], // point of the icon which will correspond to marker's location
});
const icon4 = L.icon({
  iconUrl: MapPoint4,
  iconSize: [30, 30], // size of the icon
  iconAnchor: [15, 15], // point of the icon which will correspond to marker's location
});
const icon5 = L.icon({
  iconUrl: MapPoint5,
  iconSize: [30, 30], // size of the icon
  iconAnchor: [15, 15], // point of the icon which will correspond to marker's location
});

const App = () => {
  const location_list = useSelector(state => state.data.FanProjectProcessMap || []);
  const position = [23.5, 121.4];

  return (
    <div style={{ height: 500, minHeight: 500, width: 'calc(100% - 35px)' }}>
      <MapContainer style={{ height: '100%', width: '100%', borderRadius: 30 }} center={position} zoom={8} minZoom={7} scrollWheelZoom>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url='https://wmts.nlsc.gov.tw/wmts/EMAP2/default/EPSG:3857/{z}/{y}/{x}'
        />
        {
          location_list.map((o = {}, i) => {
            switch (o.state) {
            case '0':return (
              <Marker key={i} position={[o.latitude, o.longtitude]} icon={icon1}>
                <Popup>
                  {`[基樁安裝中] - ${o.fan_point}`}
                </Popup>
              </Marker>
            );
            case '1':return (
              <Marker key={i} position={[o.latitude, o.longtitude]} icon={icon2}>
                <Popup>
                  {`[基樁安裝完成] - ${o.fan_point}`}
                </Popup>
              </Marker>
            );
            case '2':return (
              <Marker key={i} position={[o.latitude, o.longtitude]} icon={icon3}>
                <Popup>
                  {`[水下基礎(套筒)安裝完成] - ${o.fan_point}`}
                </Popup>
              </Marker>
            );
            case '3':return (
              <Marker key={i} position={[o.latitude, o.longtitude]} icon={icon4}>
                <Popup>
                  {`[風力機安裝完成] - ${o.fan_point}`}
                </Popup>
              </Marker>
            );
            case '4':return (
              <Marker key={i} position={[o.latitude, o.longtitude]} icon={icon5}>
                <Popup>
                  {`[風力機併聯完成] - ${o.fan_point}`}
                </Popup>
              </Marker>
            );
            default:return null;
            }
          })
        }

      </MapContainer>
    </div>
  );
};
export default App;
